var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuaranteedTutionRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 105,
    viewBox: "0 0 104 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5103 86.8155C71.4989 86.8155 86.8923 71.4222 86.8923 52.4336C86.8923 33.4451 71.4989 18.0518 52.5103 18.0518C33.5217 18.0518 18.1285 33.4451 18.1285 52.4336C18.1285 71.4222 33.5217 86.8155 52.5103 86.8155Z",
    fill: "#EBE349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0509 81.2794C67.9985 81.2794 80.9265 68.3514 80.9265 52.4039C80.9265 36.4563 67.9985 23.5283 52.0509 23.5283C36.1034 23.5283 23.1755 36.4563 23.1755 52.4039C23.1755 68.3514 36.1034 81.2794 52.0509 81.2794Z",
    fill: "#E8C932"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5 90.9009V62.7175L85.3713 71.6069C78.7163 83.1349 66.2588 90.9009 52 90.9009C30.7563 90.9009 13.5 73.6501 13.5 52.4009V49.6509H8V52.4009C8 76.6848 27.7175 96.4009 52 96.4009C65.1312 96.4009 76.9287 90.6327 85 81.4931V88.1509V90.9009H90.5Z",
    fill: "#70A7EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 13.9009V42.0843L18.6287 33.1949C25.2837 21.6669 37.7413 13.9009 52 13.9009C73.2438 13.9009 90.5 31.1516 90.5 52.4009V55.1509H96V52.4009C96 28.117 76.2825 8.40088 52 8.40088C38.8687 8.40088 27.0712 14.169 19 23.3086V16.6509V13.9009H13.5Z",
    fill: "#70A7EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.75 33.1509H38.25V38.6509H46.5C50.0887 38.6509 53.1413 40.9471 54.2825 44.1509H38.25V49.6509H54.2825C53.155 52.8546 50.0887 55.1509 46.5 55.1509H38.25V60.4859L55.6438 76.4276L59.3562 72.3741L46.5688 60.6495C53.1963 60.6192 58.7101 55.9058 59.9751 49.6509H65.75V44.1509H59.9751C59.5626 42.1186 58.6963 40.25 57.5 38.6509H65.75V33.1509Z",
    fill: "#F9F489"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuaranteedTutionRefund);
export default __webpack_public_path__ + "static/media/guaranteed-tution-refund.f0ae3857e13c517e93cb022331533013.svg";
export { ForwardRef as ReactComponent };